import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["disabled", "value", "maxlength"]


export default /*@__PURE__*/_defineComponent({
  __name: 'InputField',
  props: {
  inputClass: {
    type: String,
    default: ''
  },
  inputLabel: {
    type: String
  },
  isDisabled: {
    type: Boolean,
    default: false
  },
  rootClass: {
    type: String,
    default: 'inputWrapper'
  },
  projectName: {
    type: String
  },
  maxLength: {
    type: Number,
    default: 20
  }
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(__props.rootClass)
  }, [
    _createElementVNode("label", null, _toDisplayString(__props.inputLabel), 1),
    _createElementVNode("input", {
      type: "text",
      disabled: __props.isDisabled,
      value: __props.projectName,
      onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('onChange', $event))),
      class: _normalizeClass(__props.inputClass),
      maxlength: __props.maxLength
    }, null, 42, _hoisted_1)
  ], 2))
}
}

})